import Vue from 'vue'
import VueRouter from 'vue-router'
import vuetify from './plugins/vuetify'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import VueTheMask from 'vue-the-mask'
import VCurrencyField from 'v-currency-field'
import {VTextField} from 'vuetify/lib'

const VueMoment = require('vue-moment')
const moment = require('moment-timezone')
moment.tz.setDefault('America/Sao_Paulo')

require('moment/locale/pt-br')
moment.locale('pt-br')
const VueCookie = require('vue-cookie')

import 'vuetify/dist/vuetify.min.css'

import actions from './attrs/actions'
import mutations from './attrs/mutations'
import App from './components/App/Index'
import router from './router/index'
import 'vue-advanced-cropper/dist/style.css'

Vue.component('v-text-field', VTextField)

Vue.use(VueRouter)
    .use(Vuex)
    .use(vuetify)
    .use(VueTheMask)
    .use(VueMoment, {moment})
    .use(VCurrencyField, {
        locale: 'pt-BR',
        decimalLength: 2,
        autoDecimalMode: true,
        min: null,
        max: null,
        defaultValue: 0
    })
    .use(VueCookie)

Vue.filter('strip_paragraph', function (value) {
    return value.replace(/<p>(.*?)<\/p>/g, '$1 ')
})



const vuexLocal = new VuexPersistence({
    storage: window.localStorage
})

const store = new Vuex.Store({
    state: {
        acceptedCookies: false,
        loading: false,
        settings: [],
        defaultEventViewType: 'calendar',
        skipDateBlockingAlert: false,
        year: new Date().getFullYear(),
        userLogin: null,
        session: {
            token: null,
            refreshToken: null,
            user: {
                workProfiles: []
            },
            favoriteWorkProfiles: []
        },
        castSearch: {
            query: {},
            profiles: [],
            page: 1,
            result: [],
            reachedEnd: false
        },
        profileBackups: {},
        profileFinder: {
            query: {},
            profiles: [],
            event: {},
            currentIndex: 1,
            page: 1,
            result: [],
            reachedEnd: false,
            profileSearchId: null
        },
        profileSearchSymplaEventsUsed: [],
        profilesFoundBySymplaEvents: {},
        symplaEvents: [],
        creatingEvent: null,
        profileSearches: [],
        profileSearchTypes: {},
        profileSearchFilters: {},
        castSearchFilters: {},
        jobDetails: {
            foodIncluded: false,
            uniformIncluded: false,
            socialClothing: false,
            uniformDetails: null,
            fee: null
        },
        unreadMessages: [],
        impersonationData: {
            email: null,
            token: null
        },
        jobsSynced: false,
    },
    actions,
    mutations,
    plugins: [vuexLocal.plugin]
})

router.beforeEach((to, from, next) => {
    if (!store.state.impersonationData.email && to.meta.private && (!store.state.session.token || !store.state.session.user)) {
        store.commit('unsetTokens')
        next({name: 'Home'})
        return
    }

    next()
})

new Vue({
    router,
    vuetify,
    store,
    render: h => h(App)
}).$mount('#app')
